/**
 *
 * Asynchronously loads the component for LabelTypePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LabelTypePage = lazyLoad(
  () => import('./index'),
  module => module.LabelTypeEdit,
);
